import React, { useState } from 'react';
import { Dropdown } from 'react-bootstrap';
import { ReactComponent as ShareIcon } from '../../assets/images/share.svg';

export const SingleShareButton = ({shareUrl, title}) => {
  const [showDropdown, setShowDropdown] = useState(false);

  const handleShare = () => {
    if (navigator.share) {
      navigator
        .share({
          title: title,
          url: shareUrl,
        })
        .catch((err) => console.error('Error sharing:', err));
    } else {
      setShowDropdown(!showDropdown);
    }
  };

  const copyLink = () => {
    navigator.clipboard.writeText(window.location.href).then(() => {
      alert('Link copied to clipboard!');
      setShowDropdown(false);
    });
  };

  return (
    <Dropdown show={showDropdown} onToggle={() => setShowDropdown(!showDropdown)}>
      <Dropdown.Toggle
        as="button"
        onClick={handleShare}
        style={{
          background: 'none',
          border: 'none',
          padding: 0,
          cursor: 'pointer',
        }}
        aria-label="Share"
      >
        <ShareIcon width={24} height={24} />
      </Dropdown.Toggle>

      {!navigator.share && (
        <Dropdown.Menu align="end">
          <Dropdown.Item
            href={`https://twitter.com/intent/tweet?url=${shareUrl}&text=${title}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Share on Twitter
          </Dropdown.Item>
          <Dropdown.Item
            href={`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            Share on Facebook
          </Dropdown.Item>
          <Dropdown.Item href={`mailto:?subject=${title}&body=${shareUrl}`}>
            Share via Email
          </Dropdown.Item>
          <Dropdown.Item as="button" onClick={copyLink}>
            Copy Link
          </Dropdown.Item>
        </Dropdown.Menu>
      )}
    </Dropdown>
  );
};